/**
 * 全局分页器
 */
// 缓存
export function setKeepAlivePage (state, obj) {
  let {
    name,
    value
  } = obj
  if (value) {
    state.keepAlivePage = value
    return
  }
  let index = state.keepAlivePage.indexOf(name)
  if (name && index === -1) {
    state.keepAlivePage.push(name)
  }
}
// 去除某个页面缓存
export function removeKeepAlivePage (state, obj) {
  let {
    name,
    value
  } = obj
  if (value) {
    state.keepAlivePage = value
    return
  }
  let index = state.keepAlivePage.indexOf(name)
  if (index > -1) state.keepAlivePage.splice(index, 1)
}
// 保存缓存的路径
export function setKeepAliveRoutes (state, value) {
  state.routes.push(value)
}
// 当前菜单tab
export function getTab (state, menu) {
  state.currentMenu = menu
}
// 数据备份
export function backupList (state, ary) {
  state.originList = ary
}

// 数据还原
export function resetList (state) {
  state.tableList = state.originList
}

// 全局分页索引
export function setPaginationIndex (state, index) {
  state.paginationIndex = Number(index)
}

// 全局分页偏移量
export function setPaginationOffset (state, offset) {
  state.paginationOffset = Number(offset)
}

// 重置分页参数
export function resetPaginationParams (state) {
  state.tableList = []
  state.paginationOffset = 10
  state.paginationIndex = 1
}

// 重置后端分页参数
export function resetAdminPaginationParams (state) {
  state.tableList = []
}

// 应用管理数据初始化
export function setSysTableList (state, ary) {
  state.tableList = ary
}

// 降序
export function descSortListByParam (state, param) {
  let arr = state.tableList.slice()
  arr.sort((a, b) => {
    if (a[param] > b[param]) return -1
    else if (a[param] < b[param]) return 1
    else return 0
  })
  state.tableList = arr
}

// 升序
export function ascSortListByParam (state, param) {
  let arr = state.tableList.slice()
  arr.sort((a, b) => {
    if (a[param] > b[param]) return 1
    else if (a[param] < b[param]) return -1
    else return 0
  })
  state.tableList = arr
}

/**
 * init form data
 */
export function setFormData (state, obj) {
  state.form = Object.assign({}, obj)
}

/**
 * update
 */
export const updateBase = (state, kv) => {
  state[kv.name] = kv.value
}

/**
 * 设置后端分页一页显示数量
 * @param state
 * @param size
 */
export const setAdminPaginationOffset = (state, size) => {
  state.adminPaginationOffset = size
}

/**
 * 设置后端分页初始值
 * @param state
 * @param index
 */
export const setAdminPaginationIndex = (state, index) => {
  state.adminPaginationIndex = index
}

/**
 * 设置后端分页最大分页数
 * @param state
 * @param number
 */
export const setAdminMaxPagination = (state, number) => {
  state.adminMaxPagination = number
}

/**
 * 设置后端分页最大条数
 * @param state
 * @param number
 */
export const setAdminListLen = (state, number) => {
  state.adminListLen = number
}

/**
 * 设置: 后端分页当前页面改变需要刷新数据
 * @param state
 * @param b True OR False
 */
export const setAdminIndex2Fresh = (state, b) => {
  state.adminIndex2Fresh = b
}



// WEBPACK FOOTER //
// ./src/store/common/mutations.js